import useId from '../utils/useId';
import * as React from 'react';
export const stripeclimateSvg = React.forwardRef(function stripeclimateSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.604 16.363c-2.778 0-5.906-1.926-8.604-3.778-2.86-1.975-6.004-4.583-8.604-4.583C4.739 8.002 3 10.432 3 12.585v.186c0 7.18 5.82 13 13 13s13-5.82 13-13c-.087 1.743-1.32 3.592-4.396 3.592Z',
      fill: `url(#bi_stripeclimate__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.604 8.01c-2.6 0-5.744 2.6-8.604 4.575-2.697 1.852-5.826 3.778-8.604 3.778-3.076 0-4.309-1.849-4.396-3.592 0 7.18 5.82 13 13 13s13-5.82 13-13v-.187c0-2.153-1.739-4.582-4.396-4.574Z',
      fill: `url(#bi_stripeclimate__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 12.585c2.698 1.852 5.826 3.778 8.604 3.778 3.076 0 4.309-1.849 4.396-3.591 0 7.18-5.82 13-13 13s-13-5.82-13-13c.087 1.742 1.32 3.59 4.396 3.59 2.778 0 5.907-1.925 8.604-3.777Z',
      fill: `url(#bi_stripeclimate__c_${id_2})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_stripeclimate__a_${id_0}`,
          x1: 15.998,
          y1: 16.064,
          x2: 15.998,
          y2: 8.878,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#FFD748',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.21,
          stopColor: '#FFD644',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.33,
          stopColor: '#FFD438',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.45,
          stopColor: '#FFD024',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.57,
          stopColor: '#FFCB09',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#FFC900',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_stripeclimate__b_${id_1}`,
          x1: 16,
          y1: 8.87,
          x2: 16,
          y2: 16.891,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#009C00',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#00BA18',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_stripeclimate__c_${id_2}`,
          x1: 16,
          y1: 25.585,
          x2: 16,
          y2: 12.585,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.13,
          stopColor: '#00CB1B',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#00D924',
        }),
      ),
    ),
  );
});
stripeclimateSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var stripeclimate = {
  category: 'brand',
  colorable: false,
  name: 'stripeclimate',
  svg: stripeclimateSvg,
};
